import React from 'react';
import { Typography, Box, Link } from '@mui/material';
import styled from '@emotion/styled';

const StyledList = styled('ul')({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'inline-flex',
  alignItems: 'center',
});

const StyledListItem = styled('li')({
  marginRight: '20px',
  marginLeft: '20px',
  '&:first-of-type': {
    marginLeft: 0,
  },
  '&:last-of-type': {
    marginRight: 0,
  },
});

const AppFooter = styled(Box)({
  position: 'relative',
  bottom: '0px',
  minHeight: 'var(--footer-height)',
  height: 'var(--footer-height)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 16px',
});

const dataLayer = window['dataLayer'] || [];

export const FooterComponent: React.FC = () => {
  return (
    <AppFooter className="hide-on-fullscreen">
      <StyledList>
        <StyledListItem>
          <Link
            href="mailto:sales@gentian.io"
            color="inherit"
            onClick={() => {
              if (dataLayer) {
                dataLayer.push({ event: 'contact_us_platform' });
              }
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Contact Us
            </Typography>
          </Link>
        </StyledListItem>
        <li>-</li>
        <StyledListItem>
          <Link href="/terms-and-conditions" color="inherit">
            <Typography variant="body2" color="text.secondary">
              Terms and Conditions
            </Typography>
          </Link>
        </StyledListItem>
        <li>-</li>
        <StyledListItem>
          <Link href="/end-user-licence-agreement" color="inherit">
            <Typography variant="body2" color="text.secondary">
              End User Licence Agreement
            </Typography>
          </Link>
        </StyledListItem>
        <li>-</li>
        <StyledListItem>
          <Link href="/privacy-policy" color="inherit">
            <Typography variant="body2" color="text.secondary">
              Privacy Policy
            </Typography>
          </Link>
        </StyledListItem>
        <li>-</li>
        <StyledListItem>
          <Link href="/release-notes" color="inherit">
            <Typography variant="body2" color="text.secondary">
              Release Notes
            </Typography>
          </Link>
        </StyledListItem>
      </StyledList>
    </AppFooter>
  );
};
